import React, { forwardRef } from "react";
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

const PrintInvoice = forwardRef(({ data, customer }, ref) => {
  if (!data) return null;

  // Compact Styling Constants
  const labelStyle = { fontSize: "0.7rem", fontWeight: "700", color: "#444", textTransform: "uppercase" };
  const valueStyle = { fontSize: "0.75rem", fontWeight: "700", color: "#000" };
  const cellStyle = { fontSize: "0.88rem", padding: "3px 6px", border: "1px solid #000", lineHeight: 1.2 };
  const tableHeaderStyle = { ...cellStyle, fontWeight: "bold", bgcolor: "#f2f2f2", fontSize: "0.88rem" };

  return (
    <Box
      ref={ref}
      style={{
        width: "800px",
        margin: "0 auto",
        background: "#fff",
        padding: "20px",
        border: "2px solid #000",
        fontFamily: "'Segoe UI', Tahoma, sans-serif",
        color: "#000",
        boxSizing: "border-box"
      }}
    >
      {/* 1. HEADER: FIRM DETAILS CENTERED */}
      <div style={{ textAlign: "center", borderBottom: "2px solid #000", paddingBottom: "10px", marginBottom: "10px" }}>
        <h1 style={{ margin: 0, fontSize: "24px", fontWeight: "900", letterSpacing: "1px" }}>
          Vishwajeet Khadi Kendra
        </h1>
        <p style={{ margin: "5px 0", fontSize: "13px", fontWeight: "500" }}>
          Dharashiv, Maharashtra | Mo. +91 75076 01020
        </p>
        <p style={{ margin: 0, fontSize: "13px", color: "blue", fontWeight: "bold" }}>
          
        </p>
      </div>

      {/* 2. INVOICE NO & DATE BAR */}
      <div style={{ display: "flex", border: "1px solid #000", marginBottom: "10px" }}>
        <div style={{ flex: 1, padding: "10px", borderRight: "1px solid #000", textAlign: "center" }}>
          <div style={{ fontSize: "11px", fontWeight: "700", color: "#444", textTransform: "uppercase" }}>Invoice No</div>
          <div style={{ fontSize: "15px", fontWeight: "900" }}>{data.invoiceNo}</div>
        </div>
        <div style={{ flex: 1, padding: "10px", textAlign: "center", backgroundColor: "#f2f2f2" }}>
          <div style={{ fontSize: "18px", fontWeight: "900", letterSpacing: "2px" }}> INVOICE</div>
        </div>
        <div style={{ flex: 1, padding: "10px", borderLeft: "1px solid #000", textAlign: "center" }}>
          <div style={{ fontSize: "11px", fontWeight: "700", color: "#444", textTransform: "uppercase" }}>Date</div>
          <div style={{ fontSize: "15px", fontWeight: "900" }}>{data.invoiceDate}</div>
        </div>
      </div>

      {/* 3. CUSTOMER DETAILS SECTION */}
      <div style={{ border: "1px solid #000", padding: "10px", marginBottom: "10px", backgroundColor: "#fafafa" }}>
        <div style={{ fontSize: "11px", fontWeight: "700", color: "#444", textTransform: "uppercase", marginBottom: "5px" }}>Bill To:</div>
        <div style={{ fontSize: "16px", fontWeight: "800", marginBottom: "2px" }}>{data.customerName}</div>
        <div style={{ fontSize: "13px", color: "#333" }}>{customer?.address} {customer?.city} {customer?.state}</div>
        <div style={{ fontSize: "13px", color: "#333" }}><strong>Mob:</strong> {customer?.mobile}</div>
      </div>

      {/* 4. ITEMS TABLE */}
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px", tableLayout: "fixed", border: "1px solid #000" }}>
        <thead>
          <tr style={{ backgroundColor: "#f2f2f2" }}>
            <th style={{ width: "40px", border: "1px solid #000", padding: "6px", fontSize: "12px" }}>SR</th>
            <th style={{ border: "1px solid #000", padding: "6px", fontSize: "12px", textAlign: "left" }}>DESCRIPTION</th>
            <th style={{ width: "50px", border: "1px solid #000", padding: "6px", fontSize: "12px", textAlign: "right" }}>QTY</th>
            <th style={{ width: "80px", border: "1px solid #000", padding: "6px", fontSize: "12px", textAlign: "right" }}>RATE</th>
            <th style={{ width: "80px", border: "1px solid #000", padding: "6px", fontSize: "12px", textAlign: "right" }}>CGST(5%)</th>
            <th style={{ width: "80px", border: "1px solid #000", padding: "6px", fontSize: "12px", textAlign: "right" }}>SGST(5%)</th>
            <th style={{ width: "100px", border: "1px solid #000", padding: "6px", fontSize: "12px", textAlign: "right" }}>TOTAL</th>
          </tr>
        </thead>
        <tbody>
          {data.items.map((item, index) => {
            const rowCgst = item.cgst || (item.total * 0.05);
            const rowSgst = item.sgst || (item.total * 0.05);
            return (
              <tr key={index}>
                <td style={{ border: "1px solid #000", padding: "6px", fontSize: "13px", textAlign: "center" }}>{index + 1}</td>
                <td style={{ border: "1px solid #000", padding: "6px", fontSize: "13px", fontWeight: "600" }}>{item.productName}</td>
                <td style={{ border: "1px solid #000", padding: "6px", fontSize: "13px", textAlign: "right" }}>{item.qty}</td>
                <td style={{ border: "1px solid #000", padding: "6px", fontSize: "13px", textAlign: "right" }}>{item.rate}</td>
                <td style={{ border: "1px solid #000", padding: "6px", fontSize: "13px", textAlign: "right" }}>₹{Number(rowCgst).toFixed(2)}</td>
                <td style={{ border: "1px solid #000", padding: "6px", fontSize: "13px", textAlign: "right" }}>₹{Number(rowSgst).toFixed(2)}</td>
                <td style={{ border: "1px solid #000", padding: "6px", fontSize: "13px", textAlign: "right", fontWeight: "800" }}>₹{Number(item.total).toLocaleString()}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* 5. SUMMARY SECTION */}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <div style={{ width: "240px", border: "1px solid #000", borderRadius: "2px", overflow: "hidden" }}>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "5px 10px", borderBottom: "1px solid #eee" }}>
            <span style={{ fontSize: "11px", fontWeight: "700", color: "#444", textTransform: "uppercase" }}>Total Tax:</span>
            <span style={{ fontSize: "13px", fontWeight: "700" }}>₹{Number(data.cgst + data.sgst).toLocaleString()}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 10px", backgroundColor: "#000", color: "#fff" }}>
            <span style={{ fontSize: "12px", fontWeight: "bold" }}>GRAND TOTAL:</span>
            <span style={{ fontSize: "14px", fontWeight: "900" }}>₹{Number(data.grandTotal).toLocaleString()}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "5px 10px", backgroundColor: "#fff3e0" }}>
            <span style={{ fontSize: "11px", fontWeight: "700", color: "#444", textTransform: "uppercase" }}>Balance Due:</span>
            <span style={{ fontSize: "13px", fontWeight: "900", color: "#d32f2f" }}>₹{Number(data.remaining).toLocaleString()}</span>
          </div>
        </div>
      </div>

      {/* 6. SIGNATURES */}
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "40px", alignItems: "flex-end" }}>
        <div style={{ textAlign: "center", width: "150px" }}>
          <div style={{ borderTop: "1px solid #000", marginBottom: "5px" }}></div>
          <div style={{ fontSize: "11px", fontWeight: "bold", textTransform: "uppercase" }}>Receiver's Signature</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "40px" }}>For Vishwajeet Khadi Kendra</div>
          <div style={{ borderTop: "1px solid #000", display: "inline-block", paddingTop: "5px" }}>
            <div style={{ fontSize: "11px", fontWeight: "bold", textTransform: "uppercase" }}>Authorized Signatory</div>
          </div>
        </div>
      </div>
    </Box>
  );
});

export default PrintInvoice;